"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CustomerQuoteVariant;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = require("@linaria/react");
var _core = require("@linaria/core");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _image = require("@site/pattern-library-core/image");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = _interopRequireDefault(require("react"));
var _text = _interopRequireDefault(require("@ux/text"));
/* VENDOR */

/* LOCAL */

// TODO: Update border color to use intents
const DefaultContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "DefaultContainer",
  class: "pl-dh0uggo"
});
const ContentContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "ContentContainer",
  class: "pl-c2kg9k6"
});
const FeaturedContainer = /*#__PURE__*/(0, _react.styled)(_image.LazyBackgroundImage)({
  name: "FeaturedContainer",
  class: "pl-f74jjrw"
});
const CustomerImage = /*#__PURE__*/(0, _react.styled)(_image.LazyBackgroundImage)({
  name: "CustomerImage",
  class: "pl-c22vgo8"
});
const AttributionText = /*#__PURE__*/(0, _react.styled)("div")({
  name: "AttributionText",
  class: "pl-apmge69"
});
const quote = "pl-qmlljy1";

/**
 * Render the product tile, customer quote variant.
 * @memberof module:ProductTile
 *
 * @param {object} props React props
 * @param {boolean} props.renderAsHeroTile Featured tile
 * @param {string} props.customerDomain Customer domain
 * @param {string} props.customerName Customer name
 * @param {string} props.customerQuote Customer quote text
 * @param {object} props.customerWebsite Screenshot of customer website
 * @param {object} props.landscape Tile background image landscape dimensions
 * @param {object} props.portrait Tile background image portrait dimensions
 * @returns {React.ReactElement} Product tile, customer quote variant
 * @public
 */
function CustomerQuoteVariant({
  renderAsHeroTile,
  featuredImagePortrait,
  featuredImageLandscape,
  customerDomain,
  customerName,
  customerQuote,
  customerWebsite,
  ...rest
}) {
  const {
    isMobile
  } = (0, _patternLibraryUtils.useDeviceDetect)();
  const RenderElement = renderAsHeroTile && !isMobile ? FeaturedContainer : DefaultContainer;
  return /*#__PURE__*/_react2.default.createElement(RenderElement, (0, _extends2.default)({
    isPromo: false,
    landscape: featuredImageLandscape?.url ?? featuredImagePortrait?.url,
    portrait: featuredImagePortrait?.url
  }, rest), /*#__PURE__*/_react2.default.createElement(ContentContainer, null, /*#__PURE__*/_react2.default.createElement(CustomerImage, {
    isPromo: false,
    landscape: customerWebsite?.url,
    portrait: customerWebsite?.url,
    dataCy: "tile-image"
  }), /*#__PURE__*/_react2.default.createElement(_text.default.h2, {
    as: "title",
    "data-cy": "heading",
    size: 2,
    className: quote,
    text: customerQuote
  }), /*#__PURE__*/_react2.default.createElement(AttributionText, null, /*#__PURE__*/_react2.default.createElement(_text.default.p, {
    "data-cy": "attribution1",
    as: "paragraph",
    text: customerName
  }), /*#__PURE__*/_react2.default.createElement(_text.default.p, {
    "data-cy": "attribution2",
    as: "title",
    text: customerDomain
  }))));
}
CustomerQuoteVariant.propTypes = {
  featuredCategory: _propTypes.default.shape({
    Text: _propTypes.default.string
  }),
  renderAsHeroTile: _propTypes.default.bool,
  featuredImagePortrait: _propTypes.default.object,
  featuredImageLandscape: _propTypes.default.object,
  customerDomain: _propTypes.default.string,
  customerName: _propTypes.default.string,
  customerQuote: _propTypes.default.string,
  customerWebsite: _propTypes.default.object,
  landscape: _propTypes.default.object,
  portrait: _propTypes.default.object
};